import { render, staticRenderFns } from "./lsAdminDialog.vue?vue&type=template&id=1ae4b856&"
import script from "./lsAdminDialog.vue?vue&type=script&lang=js&"
export * from "./lsAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./lsAdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports